import React from 'react';
import './Videos.scss';

import video1 from '../../assets/img/car/paint-correction.mp4';
import video2 from '../../assets/img/car/boat-detail.mp4';
import video3 from '../../assets/img/car/teak-clean.mp4';


const videos = [
    {
        id: 1,
        src: video1,
      
    },

    {
        id: 2,
        src: video2,
    },

    {
        id: 3,
        src: video3,
       
    },
];


const Videos = () => {
    return (
        <section className="videos">

            <div className="videos__header">
                <h1 className="videos__title">
                    Videos
                </h1>
            </div>

            <div className="videos__list">

                {videos.map((video) => (
                    <article
                        className="videos__item"
                        key={video.id}
                    >

                        <video
                            className="videos__video"
                            src={video.src}
                            controls
                            muted
                            playsInline
                        />

                     

                    </article>
                ))}

            </div>

        </section>
    );
};


export default Videos;